import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../auth/auth.service';
import { Pair } from '../../../interfaces/pair';
import { PairService } from '../../../services/pair.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

const otherReason = 'Other reason: ';
const reasonsWhenTransplanted = ['Transplanted within cross-over program'];
const transplantedReasons = [
  'Transplanted within cross-over program',
  'Transplanted with postmortal kidney',
  'Transplanted with kidney of other living donor',
  'Transplanted with kidney of an altruist in domino chain',
  'Transplanted regardless of blood group incompatibility',
  'Transplanted regardless of HLA incompatibility'
];
const reasonsWhenNotTransplanted = [
  'Transplanted with postmortal kidney',
  'Transplanted with kidney of other living donor',
  'Transplanted with kidney of an altruist in domino chain',
  'Transplanted regardless of blood group incompatibility',
  'Transplanted regardless of HLA incompatibility',
  'Patient or donor deceased',
  'Medical problems patient',
  'Psychological problems patient',
  'Medical problems donor',
  'Psychological problems donor',
  otherReason
];
const reasons = [...reasonsWhenTransplanted, ...reasonsWhenNotTransplanted];

// To satisfy the compiler in the HTML, if we optionally use `.name || ...`
export interface OptionalName {
  name?: string;
}
export interface OptionalNames {
  donor: OptionalName;
  recipient?: OptionalName;
}

@Component({
  selector: 'app-remove-dialog',
  imports: [MatDialogModule, MatFormFieldModule, MatButtonModule, CommonModule, ReactiveFormsModule, FormsModule, MatOptionModule, MatSelectModule, MatInputModule],
  providers: [NotifyService],
  templateUrl: './remove-dialog.component.html',
  styleUrl: './remove-dialog.component.scss'
})
export class RemoveDialogComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly pairService: PairService,
    private readonly ref: MatDialogRef<RemoveDialogComponent>,
    private readonly notify: NotifyService,
    @Inject(MAT_DIALOG_DATA) readonly pair: Pair
  ) {}

  selectedReason: string | undefined = undefined;
  otherReason: string | undefined = undefined;
  readonly reasons$ = reasons;
  readonly transplantedReasons = transplantedReasons;

  otherReasonSelected(): this is { selectedReason: typeof otherReason } {
    return this.selectedReason === otherReason;
  }

  isTransplantedReason(reason: string): boolean {
    return transplantedReasons.includes(reason);
  }

  async remove() {
    const reason = this.otherReasonSelected() ? this.selectedReason + this.otherReason : this.selectedReason!;

    this.pairService.deletePair(this.pair.id, reason).subscribe({
      next: () => {
        this.notify.withAutodismiss(this.pair.recipient ? `Removed recipient ${this.pair.recipient.enisNumber} with donor ${this.pair.donor.enisNumber}` : `Removed altruist ${this.pair.donor.id}`);
      },
      error: (err) => {
        console.log(err);
        this.notify.withAutodismiss('Failed to delete pair. Please try again.');
      }
    });

    this.ref.close(true);
  }

  cancel() {
    this.ref.close(false);
  }
}
